import { useFieldArray } from 'react-hook-form';
import { useReferralFormContext } from '../ReferralFormContext';
import { FieldEnum, type SolutionInputType } from './sectionSchema';

const useSolutionsFieldArray = () => {
  const { control } = useReferralFormContext();
  const { fields, append, remove } = useFieldArray<SolutionInputType>({
    control,
    name: FieldEnum.solutions,
  });

  return {
    fields,
    append,
    remove,
  };
};

export default useSolutionsFieldArray;
